import React from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";

export default class AddToGlobalDatabase extends React.PureComponent{

    static propTypes = {
        language: PropTypes.string,
        customerName: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className={'col-12'}>
                <Link to={"/"+this.props.language+"/gate/"+this.props.customerName+"/global-register"} >
                    <div className="job-list half-grid cursor-pointer global-register">
                        <div className="thumb text-center">
                            <i className={'fa fa-user-plus fa-4x'}> </i>
                        </div>
                        <div className="body">
                            <div className="content">
                                <h4>
                                    {window.Translator.getSlug('RegisterToDatabaseWithoutPosition', this.props.language)}
                                </h4>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }
}